// https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleDateString

const localeDateString = (date) =>
  new Date(date).toLocaleDateString(process.env.CURRENT_LANGUAGE, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

export default localeDateString;
